import React from 'react';
import { demoStatusLabels, type DemoStatus } from '../../data/demoCenter';
export function DemoStatusBadge({
  status
}: {
  status: DemoStatus;
}) {
  const interactive = status === 'interactive';
  return <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${interactive ? 'bg-teal-pale text-navy border border-teal/30' : 'bg-surface-muted text-ink-muted border border-line'}`} data-id="element-244" data-mp="uo8v5hz3cfeo">
      <span aria-hidden="true" className={`h-1.5 w-1.5 rounded-full ${interactive ? 'bg-teal' : 'border border-ink-muted'}`} data-id="element-245" data-mp="6yy5avja45fb" />
      {demoStatusLabels[status].label}
    </span>;
}